import { render, staticRenderFns } from "./GruposPrestadoresSelect.vue?vue&type=template&id=20d2ef8a"
import script from "./GruposPrestadoresSelect.vue?vue&type=script&lang=js"
export * from "./GruposPrestadoresSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports